"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Tokens = __importStar(require("../utils/DesignTokens/tokens"));
var prepareTheme_1 = __importDefault(require("./prepareTheme"));
var CompleteTheme = prepareTheme_1.default(Tokens);
var defaultTheme = CompleteTheme;
exports.default = defaultTheme;
//# sourceMappingURL=defaultTheme.js.map